import { progressAnatomy as parts } from "@chakra-ui/anatomy";
import { mode } from "@chakra-ui/theme-tools";
import { StyleFunctionProps, createMultiStyleConfigHelpers } from "@chakra-ui/react";

const progressHelpers = createMultiStyleConfigHelpers(parts.keys);
const Progress = progressHelpers.defineMultiStyleConfig({
  baseStyle: (props: StyleFunctionProps) => ({
    filledTrack: {
      bg: mode("primary.500", "primary.400")(props)
    },
  })
});

export default Progress;
